import React from 'react'
import Button from 'srcReact/components/common2/Button'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'

function InviteButton({ inviteType = 'direct', inviteCount = 0, onClick, className, disabled }) {
  const { t } = useTranslation()

  return (
    <Button
      disabled={disabled}
      customStyle={`${styles.inviteBtn} ${className}`}
      iconPosition='start'
      size='large24'
      icon={<Icon name='send' size='large24' />}
      icon2={<Icon name='arrow-right' size='large24' />}
      text={
        inviteType === 'email'
          ? t('invite_group_mixr.byEmail.sendInvitationButtonText', { count: inviteCount })
          : t('invite_group_mixr.direct.inviteButtonText', { count: inviteCount })
      }
      handleClick={onClick}
    />
  )
}

export default InviteButton
